import React, { useEffect, useState } from 'react'
import CustomPaperBox from '../../theme/style-components/CustomPaperBox'
import CustomTabs from '../../theme/style-components/CustomTabs'
import { Box, Button, Card, CardContent, CircularProgress, LinearProgress, styled, Tooltip, Typography } from '@mui/material';
import CustomTable from '../../theme/style-components/CustomTable';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUserObject, selectCurrentUserType } from '../../store/auth/authSlice';
import { useLazyGetUserProfileQuery } from '../../store/users/usersApiSlice';
import { useLazyGetWalletStripeTransactionsQuery, useLazyGetWalletTransactionsQuery } from '../../store/wallet/walletApiSlice';
import moment from 'moment/moment';
import ComponentTitle from '../../shared/ComponentTitle';
import TabTitle from '../../shared/TabTitle';
import LottieLoader from '../loader/LottieLoader';
import CardBg from '../../assets/card_bg.png';
import CustomButton from '../../theme/style-components/CustomButton';
import WalletIcon from '../../assets/wallet.svg';
import { useGetMerchantAddressWitUserIdQuery } from '../../store/merchant/merchantApiSlice';

const Wallet = ({ availableBalance }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(15);


    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const walletColumns = [
        { id: 'id', label: 'ID' },
        { id: 'date', label: 'Date' },
        { id: 'amount', label: 'Amount' },
        { id: 'type', label: 'Type' },
        { id: 'meta_data', label: 'MetaData' },
        { id: 'note', label: 'Note' },
    ];


    const externalColumns = [
        { id: 'id', label: 'ID' },
        { id: 'date', label: 'Date' },
        { id: 'charged_amount', label: 'Charged Amount' },
        { id: 'intent_id', label: 'intent ID' },
        { id: 'status', label: 'Status' },
    ];


    const navigate = useNavigate();
    //redux logic
    let userType = useSelector(selectCurrentUserType);
    let user = useSelector(selectCurrentUserObject);

    const [transactionsToDisplay, setTransactionsToDisplay] = useState([]);
    const [externalToDisplay, setExternalToDisplay] = useState([]);
    const [externalCardDisplay, setexternalCardDisaplay] = useState([])
    const [getUserProfile] = useLazyGetUserProfileQuery();

    const {
            isLoading: isGetAddressLoading, 
            data: addressToEdit,
            isSuccess: isGetAddressSuccess,
            isError: isGetAddressError,
            error: getAddressError,
        } = useGetMerchantAddressWitUserIdQuery({userID: user?.id});

    const hasPharmachain = addressToEdit?.data?.some(
        (address) => address.subscription_name === "Pharmachain"
    );

    const tabsData = hasPharmachain
    ? [
        { label: "Wallet" },
        { label: "Wallet History" },
        { label: "External" },
      ]
    : [{ label: "Wallet History" }, { label: "External" }];

    const brangWallet= (user?.subscription_balance + user?.wallet_balance_cents || 0) / 100;

    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (user?.last_invoice_snapshot_cents) {
            const maxBalance = 500;
            const currentBalance = brangWallet; 
            setProgress((currentBalance / maxBalance) * 100);
        }
    }, [user]);

    const [getWalletTransactions, {
        isLoading,
        data: walletTrasactionReturned,
        isSuccess,
        isError,
        error,
    }] = useLazyGetWalletTransactionsQuery();

    const [getWalletStripeTransactions, {
        isLoading: isStripeTransactionsLoading,
        data: walletStripeTrasactionsReturned,
        isSuccess: isStripeTransactionsSuccess,
        isError: isStripeTransactionsIsError,
        error: isStripeTransactionsError,
    }] = useLazyGetWalletStripeTransactionsQuery();


    useEffect(() => {
        try {
            getWalletTransactions({ page, rowsPerPage }).unwrap().then((res) => {
                setTransactionsToDisplay(res)
            }).catch((err) => console.log(err))
            getWalletStripeTransactions({ page, rowsPerPage }).unwrap().then((res) => {
                setExternalToDisplay(res)
            }).catch((err) => console.log(err))
        } catch (err) {
            console.log(err);
        }
    }, [isLoading, page, rowsPerPage,activeTab])

    useEffect(() => {
        setPage(1);
        setRowsPerPage(15)
    }, [activeTab])

    //methods
    const handleCreateClick = (e) => {
        navigate("/recharge");
    };

    const [refreshWalletLoading, setRefreshWalletLoading] = useState(true);

    useEffect(() => {
        const fetchDataWithDelay = async () => {
            await new Promise((resolve) => setTimeout(resolve, 3000)); // Wait for 3 seconds
            handleRefresh();
            setRefreshWalletLoading(false);
        };

        fetchDataWithDelay();
        handleRefresh();
    }, []);

    const handleRefresh = async () => {
        try {
            setRefreshWalletLoading(true);
            await getUserProfile()
                .unwrap()
                .then((res) => {
                    console.log("refresh the balance");
                    setRefreshWalletLoading(false);
                    setBalance(`$${(res?.data?.wallet_balance_cents / 100).toFixed(2)}`);
                })
        } catch (err) {
            console.log(err);
        }
    };

    const walletData = transactionsToDisplay?.data?.length > 0 ? transactionsToDisplay.data.map((data) => ({
        id: data.id,
        date: moment.utc(data.created_at).format('DD MMMM YYYY'),
        amount: (data?.amount_cents / 100),
        type: data.trx_type,
        meta_data: data?.metadata && Object.entries(data?.metadata).map(([key, value]) => (
            <p key={key}>
                {key}: {value}
            </p>
        )),
        note: data.note,
    })) : []

    const externalData = externalToDisplay?.data?.length > 0 ? externalToDisplay.data.map((data) => ({
        id: data.id,
        date: moment.utc(data.created_at).format('DD MMMM YYYY'),
        charged_amount: (data?.charged_amount / 100),
        intent_id: data.intent_id,
        status: data.status,
    })) : [];

    const externalCard = externalCardDisplay


    const [balance, setBalance] = useState();

    const onPageChange = (value) => {
        setPage(value)
    };

    const onRowsPerPageChange = (value) => {
        setRowsPerPage(value);
    };


    const StyledCard = styled(Card)(({ theme }) => ({
        background: 'unset',
        padding: "30px 0",
        color: 'white',
        width: "100%",
        maxWidth: "460px",
        margin: "0 auto",
        borderRadius: "10px",
        boxShadow: "unset",
        marginTop: "20px",
    }));

    const BalanceItem = styled(Box)(({ theme }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(1.5),
    }));


    return (
      <Box>
        <TabTitle title="Wallet" />
        <ComponentTitle title="Wallet" />
        <CustomTabs
          tabsData={tabsData}
          activeTab={activeTab}
          onChange={handleTabChange}
        >
          {/* TAB 1 */}
          {hasPharmachain ? externalCardDisplay ? (
            <StyledCard>
              <Box
                sx={{
                  backgroundImage: `url(${CardBg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100% 100%",
                  padding: "24px 18px 13px 22px",
                  position: "relative",
                }}
              >
                <Button
                  variant="text"
                  sx={{
                    position: "absolute",
                    top: "-25px",
                    right: "0",
                    color: "#696CFF",
                    fontWeight: 600,
                    fontSize: "16px",
                    textTransform: "none",
                    background: "#1C1C2E",
                    borderRadius: "10px",
                    padding: "10px 21px 10px 18px",
                    fontFamily: "Quicksand, sans-serif",
                  }}
                  onClick={() => navigate("/recharge")}
                >
                  + Add Fund
                </Button>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingBottom: { xs: "20px", sm: "40px" },
                    flexWrap: "wrap",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: "18px", sm: "20px" },
                        fontWeight: "700",
                        fontFamily: "Quicksand, sans-serif",
                        marginBottom: "10px",
                        lineHeight: "normal",
                      }}
                    >
                      BrangChain Wallet
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: { xs: "16px", sm: "20px" },
                        color: "#6366f1",
                        mb: 2,
                        display: "flex",
                        gap: "11px",
                        alignItems: "center",
                        fontWeight: "700",
                        fontFamily: "Quicksand, sans-serif",
                      }}
                    >
                      <img src={WalletIcon} />
                      AUD {brangWallet ? brangWallet.toFixed(2) : "00.00"}
                    </Typography>
                  </Box>
                  {hasPharmachain && (
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: "#FFFFFFCC",
                            marginBottom: "7px",
                            lineHeight: "normal",
                            fontFamily: "Quicksand, sans-serif",
                          }}
                        >
                          Subscription Credits
                        </Typography>
                        <Typography
                          component="p"
                          sx={{
                            fontSize: "10px",
                            fontWeight: "500",
                            color: "#FFA726",
                            fontFamily: "Quicksand, sans-serif",
                          }}
                        >
                          <span style={{ color: "#fff", padding: "0 10px" }}>
                            :
                          </span>{" "}
                          AUD{" "}
                          {user?.subscription_balance != null
                            ? (user?.subscription_balance / 100).toFixed(2)
                            : "00.00"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: "#FFFFFFCC",
                            lineHeight: "normal",
                            fontFamily: "Quicksand, sans-serif",
                          }}
                        >
                          Top-Up Credits
                        </Typography>
                        <Typography
                          component="p"
                          sx={{
                            fontSize: "10px",
                            fontWeight: "500",
                            color: "#66BB6A",
                            fontFamily: "Quicksand, sans-serif",
                          }}
                        >
                          <span style={{ color: "#fff", padding: "0 10px" }}>
                            :
                          </span>
                          AUD{" "}
                          {user?.wallet_balance_cents != null
                            ? (user?.wallet_balance_cents / 100).toFixed(2)
                            : "00.00"}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>
                <Box>
                  <Box sx={{ position: 'relative', width: '100%', }}>
                    <LinearProgress
                      variant="determinate"
                      value={progress}
                      sx={{
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#6366f1",
                          borderRadius: 4,
                        },
                      }}
                    />
                    <Tooltip title={`AUD ${brangWallet ? brangWallet.toFixed(2) : "00.00"}`} placement="top" followCursor arrow>
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          height: '100%',
                          width: `${progress}%`,
                          zIndex: 1,
                          cursor: 'pointer',
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 0.5,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: "#9797A9",
                        fontFamily: "Quicksand, sans-serif",
                      }}
                    >
                      0.0
                    </Typography>
                    {/* <Typography
                      component="p"
                      sx={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: "#9797A9",
                        fontFamily: "Quicksand, sans-serif",
                      }}
                    >
                      AUD {user?.last_invoice_snapshot_cents ? (user?.last_invoice_snapshot_cents / 100).toFixed(2) : '00.00'} 
                    </Typography> */}
                  </Box>
                </Box>
              </Box>
            </StyledCard>
          ) : (
            <Box>
              <LottieLoader />
            </Box>
          ) : null}
          {/* TAB 2 */}
          {transactionsToDisplay &&
          transactionsToDisplay?.page_details?.count !== undefined ? (
            <CustomTable
              page={page}
              count={transactionsToDisplay?.page_details?.count}
              rowsPerPage={rowsPerPage}
              onPageChange={onPageChange}
              onRowsPerPageChange={onRowsPerPageChange}
              createButtonName="Recharge"
              isShowBalance={true}
              balance={balance}
              isShowSearch={false}
              handleCreateClick={handleCreateClick}
              isActionVisible={false}
              isCollapse={false}
              data={walletData}
              columns={walletColumns}
            />
          ) : (
            <Box>
              <LottieLoader />
            </Box>
          )}

          {/* TAB 3 */}
          {externalToDisplay &&
          externalToDisplay?.page_details?.count !== undefined ? (
            <CustomTable
              page={page}
              count={externalToDisplay?.page_details?.count}
              rowsPerPage={rowsPerPage}
              onPageChange={onPageChange}
              onRowsPerPageChange={onRowsPerPageChange}
              createButtonName="Recharge"
              isShowBalance={true}
              balance={balance}
              isShowSearch={false}
              handleCreateClick={handleCreateClick}
              isActionVisible={false}
              isCollapse={false}
              data={externalData}
              columns={externalColumns}
            />
          ) : (
            <Box>
              <LottieLoader />
            </Box>
          )}
        </CustomTabs>
      </Box>
    );
}

export default Wallet